module.exports = __webpack_public_path__ + "static/emily_home-c2291fdc54132fd9d757e35e02ec05a7.svg";